import { useEffect } from 'react'

interface SEOProps {
  title: string
  description: string
  keywords?: string
  image?: string
  url?: string
  type?: string
  noindex?: boolean
}

export default function SEO({
  title,
  description,
  keywords,
  image = 'https://www.logobrandeddoormats.co.za/images/sectionimages/HOMEHERO.jpeg',
  url = 'https://www.logobrandeddoormats.co.za',
  type = 'website',
  noindex = false,
}: SEOProps) {
  useEffect(() => {
    // Update document title
    document.title = title

    // Update or create meta tags
    const updateMetaTag = (name: string, content: string, attribute: string = 'name') => {
      let element = document.querySelector(`meta[${attribute}="${name}"]`) as HTMLMetaElement
      if (!element) {
        element = document.createElement('meta')
        element.setAttribute(attribute, name)
        document.head.appendChild(element)
      }
      element.setAttribute('content', content)
    }

    // Primary Meta Tags
    updateMetaTag('title', title)
    updateMetaTag('description', description)
    if (keywords) {
      updateMetaTag('keywords', keywords)
    }
    updateMetaTag('robots', noindex ? 'noindex, nofollow' : 'index, follow')

    // Open Graph Tags
    updateMetaTag('og:type', type, 'property')
    updateMetaTag('og:url', url, 'property')
    updateMetaTag('og:title', title, 'property')
    updateMetaTag('og:description', description, 'property')
    updateMetaTag('og:image', image, 'property')
    updateMetaTag('og:site_name', 'Logo Branded Door Mats Johannesburg', 'property')

    // Twitter Card Tags
    updateMetaTag('twitter:card', 'summary_large_image', 'property')
    updateMetaTag('twitter:url', url, 'property')
    updateMetaTag('twitter:title', title, 'property')
    updateMetaTag('twitter:description', description, 'property')
    updateMetaTag('twitter:image', image, 'property')

    // Canonical URL
    let canonical = document.querySelector('link[rel="canonical"]') as HTMLLinkElement
    if (!canonical) {
      canonical = document.createElement('link')
      canonical.setAttribute('rel', 'canonical')
      document.head.appendChild(canonical)
    }
    canonical.setAttribute('href', url)
  }, [title, description, keywords, image, url, type, noindex])

  return null
}

